import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
const FAQItem = ({
  question,
  answer
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-slate-700 py-5" data-id="element-48">
      <button className="flex justify-between items-center w-full text-left" onClick={() => setIsOpen(!isOpen)} data-id="element-49">
        <h3 className="text-lg font-medium text-white" data-id="element-50">{question}</h3>
        {isOpen ? <ChevronUpIcon size={20} className="text-orange-500" data-id="element-51" /> : <ChevronDownIcon size={20} className="text-orange-500" data-id="element-52" />}
      </button>
      {isOpen && <div className="mt-3" data-id="element-53">
          <p className="text-slate-400" data-id="element-54">{answer}</p>
        </div>}
    </div>;
};
const FAQ = () => {
  const faqs = [{
    question: 'What is FluidForm?',
    answer: 'FluidForm is a developer-first form platform that lets you build intelligent, conversational forms with just a few lines of code. Define your data schema once, and FluidForm automatically generates forms with multi-modal inputs (voice, text, files), AI-powered validation, and intelligent follow-ups. Deploy across web, Slack, WhatsApp, and more—without rebuilding for each platform.'
  }, {
    question: 'How is FluidForm different from traditional form builders?',
    answer: 'Unlike traditional forms, FluidForm supports multi-modal inputs (voice, camera, file uploads), AI-powered validation, intelligent follow-ups, and document extraction. You define your schema once, and FluidForm generates conversational interfaces that work across web, Slack, WhatsApp, and more.'
  }, {
    question: 'Do I need coding skills to use FluidForm?',
    answer: 'FluidForm is a developer-first product designed for engineers who want to build intelligent forms with code. We provide a simple React component and API that integrates in minutes. For non-technical users, we are launching an AI-powered no-code form builder soon—stay tuned!'
  }, {
    question: 'Where can I deploy FluidForm?',
    answer: 'FluidForm works across multiple channels: embed it on your website, integrate with Slack, deploy via WhatsApp, or use it in custom applications. One schema works everywhere—no need to rebuild for each platform.'
  }, {
    question: 'How does pricing work?',
    answer: 'We offer a Free plan with up to 2 forms and 50 submissions/month, perfect for testing. Our Pro plan ($59/month) includes up to 20 forms, 1,500 submissions, and advanced features. Enterprise plans offer unlimited usage and custom integrations. No credit card required to start.'
  }];
  return <section className="w-full bg-slate-900 py-20 border-t border-slate-800" id="faq" data-id="element-55">
      <div className="container mx-auto px-4" data-id="element-56">
        <div className="text-center mb-16" data-id="element-57">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-58">
            Frequently Asked Questions
          </h2>
        </div>
        <div className="max-w-3xl mx-auto" data-id="element-59">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-60" />)}
        </div>
      </div>
    </section>;
};
export default FAQ;